import React from 'react';
import { Helmet } from 'react-helmet-async';

function TermsAndConditions() {
  const sectionStyle = { fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginTop: '2.5rem', marginBottom: '1.5rem' };
  const subSectionStyle = { fontSize: '1.35rem', fontWeight: '600', color: '#1f2937', marginTop: '2rem', marginBottom: '1rem' };
  const paragraphStyle = { fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1.5rem' };
  const listStyle = { fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem', marginBottom: '1.5rem' };
  const noticeStyle = { background: '#fef3c7', padding: '1.5rem', borderRadius: '8px', border: '2px solid #fbbf24', marginBottom: '1.5rem' };

  return (
    <>
      <Helmet>
        <title>Terms and Conditions - TEJ Solutions Hub</title>
        <meta name="description" content="Terms and Conditions for TEJ Solutions Hub services including web development, mobile apps, digital marketing, SMS/email campaigns, and business financing referrals." />
      </Helmet>
      
      <div style={{ paddingTop: '100px', background: '#f9fafb', minHeight: '100vh' }}>
        <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '4rem 2rem', color: 'white', textAlign: 'center' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '0.5rem' }}>Terms and Conditions</h1>
          <p style={{ fontSize: '0.95rem', opacity: '0.85' }}>Last Updated: December 1, 2025</p>
        </div>

        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '4rem 2rem' }}>
          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
            
            <p style={paragraphStyle}>
              These Terms and Conditions ("Terms") govern your use of services provided by TEJ SUSTAINABILITY GROUP, INC., doing business as TEJ Solutions Hub ("Company," "we," "our," or "us"). By engaging our services or using our website, you agree to these Terms.
            </p>

            <h2 style={sectionStyle}>1. Services Offered</h2>
            <p style={paragraphStyle}>TEJ Solutions Hub provides the following services:</p>
            <ul style={listStyle}>
              <li><strong>Web Development:</strong> Custom websites, e-commerce platforms, web applications</li>
              <li><strong>Mobile App Development:</strong> iOS and Android applications</li>
              <li><strong>Digital Marketing:</strong> SEO, social media marketing, content strategy, PPC</li>
              <li><strong>Email Marketing:</strong> Campaign design, automation, list management</li>
              <li><strong>Cloud Infrastructure:</strong> AWS, Azure, GCP management, DevOps, security</li>
              <li><strong>SMS Marketing:</strong> Bulk SMS campaigns, A2P 10DLC compliant messaging</li>
              <li><strong>Digital Campaigns:</strong> Multi-channel campaign management</li>
              <li><strong>SMS Campaigns:</strong> TCPA compliant SMS messaging services</li>
              <li><strong>Business Financing Referrals:</strong> Connecting businesses with financing partners and lending options</li>
            </ul>

            <h2 style={sectionStyle}>2. Service Agreements</h2>

            <h3 style={subSectionStyle}>2.1 Project Scope</h3>
            <p style={paragraphStyle}>
              Each project begins with a detailed scope of work document outlining deliverables, timelines, and costs. Changes to scope require written approval and may affect pricing and timelines.
            </p>

            <h3 style={subSectionStyle}>2.2 Client Responsibilities</h3>
            <p style={paragraphStyle}>Clients agree to:</p>
            <ul style={listStyle}>
              <li>Provide accurate project requirements and specifications</li>
              <li>Supply necessary content, assets, and access credentials</li>
              <li>Respond to requests for feedback within agreed timeframes</li>
              <li>Obtain necessary licenses for third-party software/services</li>
              <li>Ensure compliance with applicable laws and regulations</li>
            </ul>

            <h3 style={subSectionStyle}>2.3 Payment Terms</h3>
            <ul style={listStyle}>
              <li>Payment schedules are defined in project agreements</li>
              <li>Typical structure: 50% upfront, 50% upon completion</li>
              <li>Monthly retainers for ongoing services</li>
              <li>Late payments may incur fees and service suspension</li>
              <li>All prices are in USD unless otherwise specified</li>
            </ul>

            <h2 style={sectionStyle}>3. Web & Mobile Development Terms</h2>

            <h3 style={subSectionStyle}>3.1 Development Process</h3>
            <p style={paragraphStyle}>Our development process includes:</p>
            <ul style={listStyle}>
              <li>Requirements gathering and analysis</li>
              <li>Design and prototyping</li>
              <li>Development and testing</li>
              <li>Client review and revisions</li>
              <li>Deployment and launch</li>
            </ul>

            <h3 style={subSectionStyle}>3.2 Revisions and Changes</h3>
            <p style={paragraphStyle}>
              Each project includes a specified number of revision rounds. Additional revisions beyond the agreed scope will be billed separately.
            </p>

            <h3 style={subSectionStyle}>3.3 Intellectual Property</h3>
            <p style={paragraphStyle}>
              Upon full payment, clients receive ownership of custom code and designs created specifically for their project. We retain rights to:
            </p>
            <ul style={listStyle}>
              <li>Reusable code libraries and frameworks</li>
              <li>Development tools and methodologies</li>
              <li>Portfolio use of project (with client approval)</li>
            </ul>

            <h3 style={subSectionStyle}>3.4 Third-Party Components</h3>
            <p style={paragraphStyle}>
              Projects may include third-party libraries, plugins, or services. Clients are responsible for compliance with third-party licenses and terms.
            </p>

            <h2 style={sectionStyle}>4. Digital Marketing Terms</h2>

            <h3 style={subSectionStyle}>4.1 Campaign Management</h3>
            <p style={paragraphStyle}>Digital marketing services include:</p>
            <ul style={listStyle}>
              <li>Strategy development and planning</li>
              <li>Content creation and optimization</li>
              <li>Campaign execution and monitoring</li>
              <li>Analytics and reporting</li>
              <li>Ongoing optimization</li>
            </ul>

            <h3 style={subSectionStyle}>4.2 Performance and Results</h3>
            <p style={paragraphStyle}>
              While we use best practices and proven strategies, we cannot guarantee specific results such as rankings, traffic, or conversions. Marketing performance depends on many factors including market conditions, competition, and client industry.
            </p>

            <h3 style={subSectionStyle}>4.3 Ad Spend</h3>
            <p style={paragraphStyle}>
              For PPC and paid advertising services, ad spend is separate from our management fees. Clients are responsible for advertising costs charged by platforms (Google, Facebook, etc.).
            </p>

            <h2 style={sectionStyle}>5. SMS/Email Communication Terms</h2>

            <h3 style={subSectionStyle}>5.1 Our Compliance Commitment</h3>
            <div style={{ background: '#dbeafe', padding: '1.5rem', borderRadius: '8px', border: '2px solid #3b82f6', marginBottom: '1.5rem' }}>
              <p style={{ fontSize: '1rem', color: '#1e40af', fontWeight: '600', lineHeight: '1.6', marginBottom: '0' }}>
                We obtain valid opt-in consent before sending SMS or marketing emails to our customers and maintain compliance with TCPA, CAN-SPAM, CTIA, and all applicable regulations.
              </p>
            </div>

            <h3 style={subSectionStyle}>5.2 Customer Consent</h3>
            <p style={paragraphStyle}>By providing your contact information and opting in, you agree that:</p>
            <ul style={listStyle}>
              <li>We may contact you via SMS, email, or phone about our services</li>
              <li>You have provided express written consent for communications</li>
              <li>You can opt out at any time using provided mechanisms</li>
              <li>Message and data rates may apply for SMS</li>
              <li>Consent is not required to purchase our services</li>
            </ul>

            <h3 style={subSectionStyle}>5.3 Prohibited Content</h3>
            <p style={paragraphStyle}>Clients may not use our services to send:</p>
            <ul style={listStyle}>
              <li>Illegal, fraudulent, or deceptive content</li>
              <li>Hate speech, harassment, or threats</li>
              <li>Adult or sexually explicit content</li>
              <li>Phishing or malware</li>
              <li>Spam or unsolicited messages</li>
              <li>Content violating carrier or platform policies</li>
            </ul>

            <h3 style={subSectionStyle}>5.4 SMS Program Terms</h3>
            <p style={paragraphStyle}>For SMS campaigns:</p>
            <ul style={listStyle}>
              <li>Message frequency varies by campaign</li>
              <li>Message and data rates may apply</li>
              <li>Recipients can reply STOP to opt-out</li>
              <li>Recipients can reply HELP for assistance</li>
              <li>Carriers are not liable for delayed/undelivered messages</li>
              <li>Consent is not a condition of purchase</li>
            </ul>

            <h3 style={subSectionStyle}>5.5 Email Communication Terms</h3>
            <p style={paragraphStyle}>Our email communications:</p>
            <ul style={listStyle}>
              <li>Include unsubscribe links in marketing emails</li>
              <li>Include our physical mailing address</li>
              <li>Use clear, non-deceptive subject lines</li>
              <li>Process opt-out requests within 10 business days</li>
              <li>Comply with CAN-SPAM Act requirements</li>
            </ul>

            <h3 style={subSectionStyle}>5.6 Messaging Platform</h3>
            <p style={paragraphStyle}>
              We use Twilio as our messaging platform to communicate with our customers. All messages sent via Twilio are subject to Twilio's Terms of Service and Acceptable Use Policy. We comply with all Twilio requirements and carrier regulations when sending communications.
            </p>

            <h2 style={sectionStyle}>6. Cloud Infrastructure Terms</h2>

            <h3 style={subSectionStyle}>6.1 Service Scope</h3>
            <p style={paragraphStyle}>Cloud infrastructure services include:</p>
            <ul style={listStyle}>
              <li>Cloud account setup and configuration</li>
              <li>Server deployment and management</li>
              <li>Security implementation and monitoring</li>
              <li>Backup and disaster recovery</li>
              <li>Performance optimization</li>
              <li>DevOps and CI/CD pipelines</li>
            </ul>

            <h3 style={subSectionStyle}>6.2 Cloud Provider Costs</h3>
            <p style={paragraphStyle}>
              Clients are responsible for all costs charged by cloud providers (AWS, Azure, GCP). Our fees cover management and optimization services only.
            </p>

            <h3 style={subSectionStyle}>6.3 Access and Security</h3>
            <p style={paragraphStyle}>
              We require appropriate access credentials to manage cloud infrastructure. All credentials are encrypted and stored securely. Access is logged and monitored.
            </p>

            <h3 style={subSectionStyle}>6.4 Uptime and Availability</h3>
            <p style={paragraphStyle}>
              While we implement best practices for reliability, we cannot guarantee 100% uptime. Service availability depends on cloud provider infrastructure and external factors beyond our control.
            </p>

            <h2 style={sectionStyle}>7. Business Financing Referral Terms</h2>

            <h3 style={subSectionStyle}>7.1 Referral Service Only</h3>
            <div style={{ background: '#fef3c7', padding: '1.5rem', borderRadius: '8px', border: '2px solid #fbbf24', marginBottom: '1.5rem' }}>
              <p style={{ fontSize: '1rem', color: '#92400e', fontWeight: '600', lineHeight: '1.6', marginBottom: '0' }}>
                IMPORTANT: TEJ Solutions Hub is NOT a lender. We are a referral service that connects businesses with financing partners. We do not make lending decisions, provide financial advice, or guarantee loan approval.
              </p>
            </div>

            <h3 style={subSectionStyle}>7.2 How Financing Referrals Work</h3>
            <p style={paragraphStyle}>When you inquire about business financing:</p>
            <ul style={listStyle}>
              <li>You provide business and financial information</li>
              <li>We share your information with approved lending partners</li>
              <li>Lending partners evaluate your financing request</li>
              <li>Lending partners make all approval decisions</li>
              <li>You work directly with the lender if approved</li>
            </ul>

            <h3 style={subSectionStyle}>7.3 Client Responsibilities for Financing</h3>
            <p style={paragraphStyle}>Clients seeking financing agree to:</p>
            <ul style={listStyle}>
              <li>Provide accurate business and financial information</li>
              <li>Consent to sharing information with lending partners</li>
              <li>Understand that approval is not guaranteed</li>
              <li>Review all loan terms directly with the lender</li>
              <li>Make independent decisions about accepting financing</li>
              <li>Comply with all lender requirements and agreements</li>
            </ul>

            <h3 style={subSectionStyle}>7.4 No Guarantee of Approval</h3>
            <p style={paragraphStyle}>
              We cannot guarantee that you will be approved for financing. Approval decisions are made solely by lending partners based on their criteria. Factors include credit history, time in business, revenue, and other financial metrics.
            </p>

            <h3 style={subSectionStyle}>7.5 Lending Partner Relationships</h3>
            <p style={paragraphStyle}>
              We work with multiple approved lending partners. When you submit a financing inquiry, your information may be shared with one or more partners. Each lending partner has their own terms, conditions, and privacy policies.
            </p>

            <h3 style={subSectionStyle}>7.6 Financing Communications</h3>
            <p style={paragraphStyle}>
              By requesting financing information, you consent to receive communications from us and our lending partners via phone, email, and SMS regarding financing options. You can opt out at any time.
            </p>

            <h3 style={subSectionStyle}>7.7 No Financial Advice</h3>
            <p style={paragraphStyle}>
              We do not provide financial, legal, or tax advice. Information provided is for general purposes only. Consult with qualified professionals before making financial decisions.
            </p>

            <h2 style={sectionStyle}>8. Warranties and Disclaimers</h2>

            <h3 style={subSectionStyle}>8.1 Service Warranties</h3>
            <p style={paragraphStyle}>We warrant that:</p>
            <ul style={listStyle}>
              <li>Services will be performed with professional skill and care</li>
              <li>Work will substantially conform to agreed specifications</li>
              <li>We have rights to provide the services offered</li>
            </ul>

            <h3 style={subSectionStyle}>8.2 Disclaimer of Warranties</h3>
            <p style={paragraphStyle}>
              EXCEPT AS EXPRESSLY STATED, SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
            </p>

            <h3 style={subSectionStyle}>8.3 Third-Party Services</h3>
            <p style={paragraphStyle}>
              We are not responsible for the performance, availability, or policies of third-party services, platforms, or providers used in delivering our services.
            </p>

            <h2 style={sectionStyle}>9. Limitation of Liability</h2>
            <p style={paragraphStyle}>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR LIABILITY FOR ANY CLAIMS ARISING FROM SERVICES SHALL NOT EXCEED THE AMOUNT PAID BY CLIENT FOR THE SPECIFIC SERVICE GIVING RISE TO THE CLAIM IN THE 12 MONTHS PRECEDING THE CLAIM.
            </p>
            <p style={paragraphStyle}>
              WE SHALL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFITS, LOST DATA, OR BUSINESS INTERRUPTION.
            </p>

            <h2 style={sectionStyle}>10. Indemnification</h2>
            <p style={paragraphStyle}>Clients agree to indemnify and hold us harmless from claims arising from:</p>
            <ul style={listStyle}>
              <li>Client's use of our services</li>
              <li>Client-provided content or materials</li>
              <li>Violation of these Terms</li>
              <li>Violation of applicable laws or regulations</li>
              <li>Infringement of third-party rights</li>
              <li>Non-compliance with SMS/email marketing regulations</li>
            </ul>

            <h2 style={sectionStyle}>11. Confidentiality</h2>
            <p style={paragraphStyle}>
              Both parties agree to maintain confidentiality of proprietary information shared during the business relationship. This includes project details, source code, business strategies, and client data.
            </p>

            <h2 style={sectionStyle}>12. Term and Termination</h2>

            <h3 style={subSectionStyle}>12.1 Project-Based Services</h3>
            <p style={paragraphStyle}>
              Project agreements terminate upon completion and final payment. Either party may terminate with written notice if the other party materially breaches the agreement.
            </p>

            <h3 style={subSectionStyle}>12.2 Ongoing Services</h3>
            <p style={paragraphStyle}>
              Ongoing services (retainers, hosting, maintenance) continue until terminated by either party with 30 days written notice.
            </p>

            <h3 style={subSectionStyle}>12.3 Effect of Termination</h3>
            <p style={paragraphStyle}>Upon termination:</p>
            <ul style={listStyle}>
              <li>Client pays for all work completed to date</li>
              <li>We provide deliverables for paid work</li>
              <li>Access credentials are revoked</li>
              <li>Confidentiality obligations continue</li>
            </ul>

            <h2 style={sectionStyle}>13. Dispute Resolution</h2>
            <p style={paragraphStyle}>
              Disputes shall first be addressed through good-faith negotiation. If unresolved, disputes shall be resolved through binding arbitration in Atlanta, Georgia, under the rules of the American Arbitration Association.
            </p>

            <h2 style={sectionStyle}>14. Governing Law</h2>
            <p style={paragraphStyle}>
              These Terms are governed by the laws of the State of Georgia, United States, without regard to conflict of law principles.
            </p>

            <h2 style={sectionStyle}>15. Changes to Terms</h2>
            <p style={paragraphStyle}>
              We may update these Terms periodically. Continued use of services after changes constitutes acceptance. Material changes will be communicated to active clients.
            </p>

            <h2 style={sectionStyle}>16. Contact Information</h2>
            <p style={paragraphStyle}>For questions about these Terms:</p>
            <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', marginTop: '1rem' }}>
              <p style={{ fontSize: '1.05rem', color: '#1f2937', lineHeight: '1.8', marginBottom: '0' }}>
                <strong>TEJ SUSTAINABILITY GROUP, INC.</strong> (d/b/a TEJ Solutions Hub)<br />
                4273 Savannah Trce, Atlanta, GA 30349<br />
                Email: <strong>contact@tejsolutionshub.com</strong><br />
                EIN: 86-3326707
              </p>
            </div>

            <h2 style={sectionStyle}>17. Third-Party Messaging Services</h2>
            <p style={paragraphStyle}>
              We use Twilio as our messaging platform to send SMS and email communications to our customers. By receiving communications from us, you acknowledge and agree that:
            </p>
            <ul style={listStyle}>
              <li>Messages are sent via Twilio's messaging platform</li>
              <li>Twilio's Acceptable Use Policy applies to all messaging</li>
              <li>Twilio's Terms of Service govern the underlying messaging infrastructure</li>
              <li>We comply with Twilio's requirements and guidelines</li>
              <li>Services may be suspended for policy violations</li>
              <li>You must comply with both our terms and Twilio's policies</li>
            </ul>
            <p style={paragraphStyle}>
              Twilio Terms: <a href="https://www.twilio.com/legal/tos" target="_blank" rel="noopener noreferrer" style={{ color: '#7c3aed', fontWeight: '600' }}>https://www.twilio.com/legal/tos</a>
            </p>
            <p style={paragraphStyle}>
              Twilio Acceptable Use Policy: <a href="https://www.twilio.com/legal/aup" target="_blank" rel="noopener noreferrer" style={{ color: '#7c3aed', fontWeight: '600' }}>https://www.twilio.com/legal/aup</a>
            </p>

            <h2 style={sectionStyle}>18. Miscellaneous</h2>

            <h3 style={subSectionStyle}>18.1 Entire Agreement</h3>
            <p style={paragraphStyle}>
              These Terms, together with project-specific agreements, constitute the entire agreement between parties.
            </p>

            <h3 style={subSectionStyle}>18.2 Severability</h3>
            <p style={paragraphStyle}>
              If any provision is found unenforceable, remaining provisions continue in full effect.
            </p>

            <h3 style={subSectionStyle}>18.3 Assignment</h3>
            <p style={paragraphStyle}>
              Clients may not assign rights or obligations without our written consent. We may assign to affiliates or in connection with a merger or acquisition.
            </p>

            <h3 style={subSectionStyle}>18.4 Force Majeure</h3>
            <p style={paragraphStyle}>
              Neither party is liable for delays or failures due to circumstances beyond reasonable control, including natural disasters, pandemics, or infrastructure failures.
            </p>

          </div>
        </div>
      </div>
    </>
  );
}

export default TermsAndConditions;
